import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
// useCallback
import { useCallback } from 'react';

import {
  IconFile,
  IconDeviceFloppy,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconMaximize,
  IconLayoutDashboard,
  IconEye,
  IconCopy,
  IconLayersLinked,
  IconRotate,
  IconCrop,
  IconAlignCenter,
  IconFlipHorizontal,
  IconTextSize,
  IconPhoto,
  IconCirclePlus,
  IconPalette,
  IconPhotoPlus,
  IconTrash,
  IconEyeOff,
  IconArrowBarDown,
  IconArrowBarUp,
  IconUpload,
  IconDownload,
  IconCloudUpload,
  IconCloudDownload,
  IconWorldDownload,
  IconX
} from '@tabler/icons-react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  fetchProductDetailForDesign,
  fetchUserCustomizeProductDesign,
  saveUserCustomizeProductDesign,
  updateCustomizeProductDesign
} from '../../redux/slices/designSlice';
// Example images (from your imports)
import emily from '../../assets/images/cat-fashion.jpg';
import james from '../../assets/images/james.png';
import sophia from '../../assets/images/sophia.png';

const AlertModal = ({ tittleMessage, messageBody, onClose }) => {

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-red-600">{tittleMessage}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className="mb-6">{messageBody}</p>
        <div className="flex justify-end">
          <button onClick={onClose} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
            OK
          </button>
        </div>
      </div>
    </div>
  );
}



const ErrorModal = ({ tittleMessage, messageBody, link = '/', buttonMessage = 'Return To Home', setShowErrorModal = null }) => {

  let button = '';
  if (setShowErrorModal) {

    button = <button onClick={() => setShowErrorModal(false)} className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400 transition ml-2">
      Cancel
    </button>

  } else {
    button = null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-red-600">
            {tittleMessage}
          </h3>
        </div>
        <p className="mb-6">
          {messageBody}
        </p>
        <div className="flex justify-end">
          <Link
            to={link}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          >
            Return to Home
          </Link>
          {/* add cancel Button */}
          {button}

        </div>
      </div>
    </div>
  );
}
const BreadcrumbForCheckout = ({ categoryId, subcategoryId, subCategoryName, categoryName, productId, isNew, projectId }) => {
  return (<div className="bg-blue-900 text-white text-sm px-6 py-2 flex items-center space-x-2">
    <nav>
      <Link to="/" className="hover:underline">
        <span>Home</span>
      </Link>
      <span className="mx-2">/</span>
      <Link to={`/category/${categoryId}`} className="hover:underline">{categoryName}</Link>
      <span className="mx-2">/</span>
      <Link to={`/category/${categoryId}/detail/${subcategoryId}`} className="hover:underline">{subCategoryName}</Link>
      <span className="mx-2">/</span>
      <Link to={`/design/${productId}/${isNew}/${projectId}`} className="hover:underline">Design</Link>

      <span className="mx-2">/</span>
      <span className="font-medium text-[#FFD700]">Checkout</span>
    </nav>
  </div>)
}
const ShimmerLoader = () => (
  <div className="animate-pulse">
    <div className="bg-gray-200 h-16 w-full"></div>
    <div className="bg-gray-300 h-8 w-full"></div>
    <div className="max-w-screen-xl mx-auto w-full px-4 mt-4">
      <div className="bg-gray-200 h-6 w-64 mb-4"></div>
      <div className="bg-gray-100 h-16 w-full mb-6"></div>
      <div className="flex gap-6">
        <div className="w-48 bg-gray-100 h-96"></div>
        <div className="flex-1 bg-gray-100 h-96"></div>
        <div className="w-52 bg-gray-100 h-96"></div>
      </div>
      <div className="mt-10 pb-12">
        <div className="bg-gray-200 h-6 w-64 mb-4"></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-gray-100 h-64"></div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// Recommended items (sample data)
const recommendedItems = [
  {
    id: 1,
    name: 'Emily’s Template',
    price: 'From $9.99',
    imgSrc: emily,
  },
  {
    id: 2,
    name: 'James’s Template',
    price: 'From $12.99',
    imgSrc: james,
  },
  {
    id: 3,
    name: 'Sophia’s Template',
    price: 'From $14.99',
    imgSrc: sophia,
  },
];


export default function Design() {


  const dispatch = useDispatch();
  const navigate = useNavigate();



  // Add these state variables near the top of your component
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [savedDesignId, setSavedDesignId] = useState(null); // Track if we have a saved design ID
  const [initialDesignState, setInitialDesignState] = useState(null); // To compare for changes

  const { productDetails, fetchProductDetailLoading, fetchProductDetailError } =
    useSelector((state) => state.design);
  const { categories } = useSelector((state) => state.home);

  const { productId, isNew = 'true', projectId } = useParams();
  const isNewDesign = isNew === 'true';

  let productFileName = (productDetails?.template_name || 'My_Card') + '.design';


  const [projectName, setProjectName] = useState(productFileName);
  const [showLayerPanel, setShowLayerPanel] = useState(false);
  const [isCropping, setIsCropping] = useState(false);

  const [showErrorModal, setShowErrorModal] = useState(false);

  // Layers
  const [frontLayers, setFrontLayers] = useState([]);
  const [backLayers, setBackLayers] = useState([]);
  const [isFront, setIsFront] = useState(true);
  const [showAlertModal, setShowAlertModal] = useState(false);

  const getCurrentLayers = () => isFront ? frontLayers : backLayers;
  const setCurrentLayers = (newLayers) => {
    isFront
      ? setFrontLayers(newLayers)
      : setBackLayers(newLayers);
  };

  // Initialize state when component mounts or product details load
  useEffect(() => {
    if (productDetails && isNewDesign && !initialDesignState) {
      const initialState = {
        frontLayers: [],
        backLayers: [],
        isFront: true,
        projectName: productFileName
      };
      setInitialDesignState(initialState);
      setFrontLayers([]);
      setBackLayers([]);
      setIsFront(true);
      setProjectName(productFileName);
    }
  }, [productDetails, productFileName, initialDesignState, isNewDesign]);

  useEffect(() => {
    // Always fetch product details first to ensure a stable loading order.
    dispatch(fetchProductDetailForDesign(productId))
      .unwrap() 
      .then(() => {
  
        if (!isNewDesign && projectId) {

          // Define the function to load the user's custom design data.
          const loadDesignFromBackend = async (projectId) => {
            try {
              // Now, dispatch the action to get the saved design.
              const designData = await dispatch(fetchUserCustomizeProductDesign(projectId)).unwrap();

              // Process layers from backend to frontend format
              const processLayer = (layer) => {
                const baseLayer = {
                  id: layer.id,
                  type: layer.type,
                  x: layer.x,
                  y: layer.y,
                  width: layer.width,
                  height: layer.height,
                  rotation: layer.rotation,
                  flipped: layer.flipped,
                  visible: layer.visible,
                  zIndex: layer.z_index,
                  border: {
                    top: layer.border_top,
                    right: layer.border_right,
                    bottom: layer.border_bottom,
                    left: layer.border_left
                  },
                  borderColor: layer.border_color,
                  borderStyle: layer.border_style,
                  cornerRadius: {
                    tl: layer.corner_radius_tl,
                    tr: layer.corner_radius_tr,
                    bl: layer.corner_radius_bl,
                    br: layer.corner_radius_br
                  },
                  offsetX: layer.offset_x,
                  offsetY: layer.offset_y
                };

                if (layer.type === 'image' && layer.image_data) {
                  return {
                    ...baseLayer,
                    src: layer.image_data.original_src || ''
                  };
                } else if (layer.type === 'text' && layer.text_data) {
                  return {
                    ...baseLayer,
                    text: layer.text_data.text,
                    color: layer.text_data.color
                  };
                }
                return baseLayer;
              };

              // Separate front and back layers
              const frontLayersData = designData.layers
                .filter(l => l.side === 'front')
                .map(processLayer);

              const backLayersData = designData.layers
                .filter(l => l.side === 'back')
                .map(processLayer);

              // Set all the component state at once with the loaded data.
              setFrontLayers(frontLayersData);
              setBackLayers(backLayersData);
              setIsFront(designData.current_side === 'front');
              setProjectName(designData.name);

              // Initialize history
              const initialHistoryState = {
                frontLayers: frontLayersData,
                backLayers: backLayersData
              };
              setHistory([initialHistoryState]);
              setHistoryIndex(0);

              // Set the initial state to compare against for unsaved changes.
              setInitialDesignState({
                frontLayers: frontLayersData,
                backLayers: backLayersData,
                isFront: designData.current_side === 'front',
                projectName: designData.name
              });
              setSavedDesignId(projectId);

            } catch (error) {
              console.error('Error loading design:', error);
              showError('Error Loading Design', 'We couldn\'t load your saved design. Please try again.');
            }
          };

          // Call the function to execute the design loading.
          loadDesignFromBackend(projectId);
        }
      })
      .catch((error) => {
        // This catch block will handle errors from the initial product detail fetch.
        console.error('Error loading product details:', error);
        showError('Error Loading Product', `We couldn't load the product details for ID: ${productId}. Please try again later.`);
      });

  }, [dispatch, productId, isNewDesign, projectId]); // Dependencies remain the same.

  useEffect(() => {
    if (fetchProductDetailError) {
      showError('Error Loading Product', `We couldn't load the product details for ID: ${productId}. Please try again later or contact support if the problem persists.`, '/', 'Return to Home');
    };
  }, [fetchProductDetailError]);

  // Undo/Redo history
  const [history, setHistory] = useState([]);
  // store initializing  error message body header utton name and link as state
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [errorModalContent, setErrorModalContent] = useState({
    title: '',
    message: '',
    link: '/',
    buttonMessage: 'Return to Home',
  });

  const [alertModalContent, setAlertModalContent] = useState({
    title: 'Alert',
    message: 'This is an alert message.',
  });


  const showError = (title, message, link = '/', buttonMessage = 'Return to Home') => {
    setErrorModalContent({ title, message, link, buttonMessage });
    setShowAlertModal(false)
    setShowErrorModal(true);
  };
  const showAlert = (title, message) => {

    setAlertModalContent({ title, message });
    setShowErrorModal(false);
    setShowAlertModal(true);
  };




  // For preview modal
  const [showPreview, setShowPreview] = useState(false);

  // Dragging
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [initPos, setInitPos] = useState({ x: 0, y: 0 });

  // Reference to T-shirt container
  const shirtRef = useRef(null);


  const getCategoryAndSubcategoryName = (categories, subCategoryId) => {
    const category = categories.find(cat => cat.subcategories.some(sub => sub.id == subCategoryId));
    if (!category) return { categoryId: null, categoryName: null, subCategoryId: null, subCategoryName: null };

    const subCategory = category.subcategories.find(sub => sub.id == subCategoryId);
    return {
      categoryId: category.id,
      categoryName: category.name,
      subcategoryId: subCategory?.id || null,
      subCategoryName: subCategory?.name || null,
    };
  };

  const { categoryId, categoryName, subcategoryId, subCategoryName } = getCategoryAndSubcategoryName(categories, productDetails?.sub_category_id);



  const checkForChanges = useCallback(() => {
    // If we don't have an initial state yet, assume no changes
    if (!initialDesignState) return false;

    // Special case: if this is a new design and we have layers, consider it changed
    if (isNewDesign && (frontLayers.length > 0 || backLayers.length > 0)) {
      return true;
    }

    const currentState = {
      frontLayers,
      backLayers,
      isFront,
      projectName
    };

    return JSON.stringify(initialDesignState) !== JSON.stringify(currentState);
  }, [frontLayers, backLayers, isFront, projectName, initialDesignState, isNewDesign]);

  useEffect(() => {
    setHasUnsavedChanges(checkForChanges());
  }, [frontLayers, backLayers, isFront, projectName, checkForChanges]);


  // Save to backend
  const saveDesignToBackend = async () => {
    try {
      // Helper function to convert blob URLs to base64
      const blobToBase64 = (blobUrl) => {
        return new Promise((resolve, reject) => {
          fetch(blobUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
            .catch(reject);
        });
      };

      // Prepare layers data
      const prepareLayers = async (layers, side) => {
        const processedLayers = [];
        for (const layer of layers) {
          const baseLayer = {
            type: layer.type,
            side: side,
            x: layer.x,
            y: layer.y,
            width: layer.width,
            height: layer.height,
            rotation: layer.rotation,
            flipped: layer.flipped,
            visible: layer.visible,
            z_index: layer.zIndex,
            border: {
              top: layer.border?.top || 0,
              right: layer.border?.right || 0,
              bottom: layer.border?.bottom || 0,
              left: layer.border?.left || 0,
            },
            border_color: layer.borderColor || '#000000',
            border_style: layer.borderStyle || 'solid',
            corner_radius: {
              tl: layer.cornerRadius?.tl || 0,
              tr: layer.cornerRadius?.tr || 0,
              bl: layer.cornerRadius?.bl || 0,
              br: layer.cornerRadius?.br || 0,
            },
            offset_x: layer.offsetX || 0,
            offset_y: layer.offsetY || 0,
          };

          if (layer.type === 'image') {
            let base64Image = layer.src;
            if (layer.src.startsWith('blob:')) {
              try {
                base64Image = await blobToBase64(layer.src);
              } catch (error) {
                console.error('Failed to convert image to base64:', error);
                base64Image = ''; // Fallback to an empty string if conversion fails
              }
            }
            processedLayers.push({
              ...baseLayer,
              image_data: {
                original_src: base64Image,
              },
            });
          } else if (layer.type === 'text') {
            processedLayers.push({
              ...baseLayer,
              text_data: {
                text: layer.text,
                color: layer.color,
              },
            });
          } else {
            processedLayers.push(baseLayer);
          }
        }
        return processedLayers;
      };

      const frontProcessedLayers = await prepareLayers(frontLayers, 'front');
      const backProcessedLayers = await prepareLayers(backLayers, 'back');

      const designData = {
        name: projectName,
        product_id: productDetails.id,
        current_side: isFront ? 'front' : 'back',
        version: '1.0',
        layers: [...frontProcessedLayers, ...backProcessedLayers],
      };


      let data;
      if (savedDesignId) {
        // Update existing design
        data = await dispatch(updateCustomizeProductDesign({
          projectId: savedDesignId,
          data: designData
        })).unwrap();
      } else {
        // Create new design
        data = await dispatch(saveUserCustomizeProductDesign(designData)).unwrap();
        setSavedDesignId(data.id);
        // After first save, this is no longer a new design
        // setIsNewDesign(false); // Uncomment if you have this state
      }

      // Update initial state after save
      setInitialDesignState({
        frontLayers,
        backLayers,
        isFront,
        projectName
      });

      setHasUnsavedChanges(false);
      setSavedDesignId(data.id); // Update saved design ID
      return data.id;

    } catch (error) {
     showAlert('Save Failed', 'Your design could not be saved. Please check your connection and try again.');
}
    
  };

  // Save as downloadable file
  const saveDesignAsFile = async () => {
    try {
      // Helper function to convert blob URLs to base64
      const blobToBase64 = (blobUrl) => {
        return new Promise((resolve, reject) => {
          fetch(blobUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
            .catch(reject);
        });
      };

      // Prepare layers data
      const prepareLayers = async (layers) => {
        const processedLayers = [];
        for (const layer of layers) {
          const baseLayer = {
            id: layer.id,
            type: layer.type,
            x: layer.x,
            y: layer.y,
            width: layer.width,
            height: layer.height,
            rotation: layer.rotation,
            flipped: layer.flipped,
            visible: layer.visible,
            zIndex: layer.zIndex,
            border: layer.border,
            borderColor: layer.borderColor,
            borderStyle: layer.borderStyle,
            cornerRadius: layer.cornerRadius,
            offsetX: layer.offsetX,
            offsetY: layer.offsetY,
          };

          if (layer.type === 'image') {
            let base64Image = layer.src;
            if (layer.src.startsWith('blob:')) {
              try {
                base64Image = await blobToBase64(layer.src);
              } catch (error) {
                console.error('Failed to convert image to base64:', error);
                base64Image = ''; // Fallback to an empty string if conversion fails
              }
            }
            processedLayers.push({
              ...baseLayer,
              src: base64Image,
            });
          } else if (layer.type === 'text') {
            processedLayers.push({
              ...baseLayer,
              text: layer.text,
              color: layer.color,
            });
          } else {
            processedLayers.push(baseLayer);
          }
        }
        return processedLayers;
      };

      const frontProcessedLayers = await prepareLayers(frontLayers);
      const backProcessedLayers = await prepareLayers(backLayers);

      const designData = {
        projectName,
        frontLayers: frontProcessedLayers,
        backLayers: backProcessedLayers,
        currentSide: isFront ? 'front' : 'back',
        version: '1.0',
      };

      // Create download
      const dataStr = JSON.stringify(designData, null, 2);
      const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;
      const exportFileName = `${projectName.replace(/\s+/g, '_')}_full.design`;

      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileName);
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
    } catch (error) {
      console.error('Error saving design:', error);

    }
  };

  // Helper function to convert blob URL to base64
  const blobToBase64 = (blobUrl) => {
    return new Promise((resolve, reject) => {
      fetch(blobUrl)
        .then(res => res.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };




  // Load from file
  const loadDesignFromFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const designData = JSON.parse(e.target.result);

        // Process layers to handle blob URLs
        const processLayers = (layers) => {
          return layers.map(layer => {
            if (layer.type === 'image' && layer.src.startsWith('blob:')) {
              // Remove blob URLs - they won't be valid after reload
              return {
                ...layer,
                src: '', // Clear the invalid blob URL
                visible: false // Hide invalid images
              };
            }
            return layer;
          });
        };

        // Process both front and back layers
        const processedFrontLayers = designData.frontLayers ? processLayers(designData.frontLayers) : [];
        const processedBackLayers = designData.backLayers ? processLayers(designData.backLayers) : [];

        setFrontLayers(processedFrontLayers);
        setBackLayers(processedBackLayers);

        // Set the current side
        setIsFront(designData.currentSide !== 'back');

        // Initialize history with both front and back layers
        const initialHistoryState = {
          frontLayers: processedFrontLayers,
          backLayers: processedBackLayers
        };
        setInitialDesignState({
          frontLayers: processedFrontLayers,
          backLayers: processedBackLayers,
          isFront: designData.currentSide !== 'back',
          projectName: designData.projectName || 'My_Card.design'
        });


        setHistory([initialHistoryState]);
        setHistoryIndex(0);
        setProjectName(designData.projectName || 'My_Card.design');

      } catch (error) {
        console.error('Error loading design:', error);
        showAlert('Error Loading Design', 'The file you selected is not a valid design file or is corrupted. Please try again with a valid design file.');
      }
    };
    reader.readAsText(file);
  };




  // Find the currently selected layer
  const [selectedId, setSelectedId] = useState(null);
  const selectedLayer = getCurrentLayers().find((l) => l.id === selectedId) || null;


  function commitHistory(newLayers) {
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push({
      frontLayers: isFront ? newLayers : frontLayers,
      backLayers: isFront ? backLayers : newLayers
    });
    setHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
    setCurrentLayers(newLayers);
    // No need to manually set hasUnsavedChanges here - the useEffect will handle it
  }


  const handleUndo = () => {
    if (historyIndex > 0) {
      const newIndex = historyIndex - 1;
      const state = history[newIndex];
      setHistoryIndex(newIndex);
      setFrontLayers(state.frontLayers);
      setBackLayers(state.backLayers);
      setSelectedId(null);
    }
  };

  const handleRedo = () => {
    if (historyIndex < history.length - 1) {
      const newIndex = historyIndex + 1;
      const state = history[newIndex];
      setHistoryIndex(newIndex);
      setFrontLayers(state.frontLayers);
      setBackLayers(state.backLayers);
      setSelectedId(null);
    }
  };


  const handleChangeTemplate = () => {
    if (hasUnsavedChanges) {
      showAlert('Unsaved Changes', 'You have unsaved changes. Please save or discard them before changing the template.');
    } else {
      navigate('/category/' + categoryId + '/detail/' + subcategoryId)
    }

  };

  const handlePreview = () => {
    // Show the preview modal
    setShowPreview(true);
  };
  const handleNext = async () => {
    const pathToNavigateToPass = [
      {
        'name': 'Home',
        'path': '/'
      },
      {
        'name': categoryName,
        'path': `/category/${categoryId}`
      },
      {
        'name': subCategoryName,
        'path': `/category/${categoryId}/detail/${subcategoryId}`
      },
      {
        'name': 'Design',
        'path': `/design/${productId}/${isNew}/${projectId}`
      },

    ];


    const currenTemplateProductId = productDetails.id;

    if (hasUnsavedChanges) {
      try {
        const designId = await saveDesignToBackend();
        navigate(`/checkout/${currenTemplateProductId}/true/${designId}`, { state: pathToNavigateToPass });
      } catch (error) {
        showAlert('Error', 'Failed to save design. Please try again.');
      }
    } else {
      if (savedDesignId) {
        navigate(`/checkout/${currenTemplateProductId}/true/${savedDesignId}`, { state: pathToNavigateToPass });
      } else {
        showError('Error', 'No saved design found. Please save your design before proceeding to checkout.', `/category/${categoryId}/detail/${subcategoryId}`, 'Ok');
      }

    }
  };

  // =========================================================
  // ========== Create Layers (text or images) ===============
  // =========================================================
  const createTextLayer = () => {
    const newLayer = {
      id: Date.now(),
      type: 'text',
      text: 'New Text',
      color: '#000000',
      x: 80,
      y: 80,
      width: 150,
      height: 40,
      rotation: 0,
      flipped: false,
      visible: true,
      zIndex: getCurrentLayers().length + 1,
      cornerRadius: { tl: 0, tr: 0, bl: 0, br: 0 },
      border: { top: 0, right: 0, bottom: 0, left: 0 },
      borderColor: '#000000',
      borderStyle: 'solid',
      offsetX: 0,
      offsetY: 0,
    };

    const currentLayers = getCurrentLayers();
    const newLayers = [...currentLayers, newLayer];
    setCurrentLayers(newLayers);
    commitHistory(newLayers);
    setSelectedId(newLayer.id);
  };

  /**
   * Create an image layer. We'll load the image to get its natural width/height,
   * then auto-scale it so it's not too big. By default we place it at (100,100).
   */
  const createImageLayer = async (src) => {
    let finalSrc = src;
    if (src.startsWith('blob:')) {
      finalSrc = await blobToBase64(src);
    }

    const img = new Image();
    img.src = finalSrc;
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      // For example, limit initial size to 300px wide
      const maxWidth = 300;
      if (w > maxWidth) {
        const ratio = maxWidth / w;
        w = maxWidth;
        h = h * ratio;
      }
      // Then create the layer
      const newLayer = {
        id: Date.now(),
        type: 'image',
        src: finalSrc, // Use the correct property name
        x: 100,
        y: 100,
        width: w,
        height: h,
        rotation: 0,
        flipped: false,
        visible: true,
        zIndex: getCurrentLayers().length + 1,
        cornerRadius: { tl: 0, tr: 0, bl: 0, br: 0 },
        border: { top: 0, right: 0, bottom: 0, left: 0 },
        borderColor: '#000000',
        borderStyle: 'solid',
        offsetX: 0,
        offsetY: 0,
      };

      const currentLayers = getCurrentLayers();
      const newLayers = [...currentLayers, newLayer];
      setCurrentLayers(newLayers);
      commitHistory(newLayers);
      setSelectedId(newLayer.id);
    };
  };

  const handleCancelAndDiscard = () => {
    navigate('/category/' + categoryId + '/detail/' + subcategoryId);
  };

  // If user clicks a recommended item
  // const handleCustomizeTemplate = (item) => {
  //   createImageLayer(item.imgSrc);
  // };

  // =========================================================
  // ========== Duplicate / Crop / Flip / Rotate, etc. =======
  // =========================================================
  const handleDuplicate = () => {
    const currentLayers = getCurrentLayers();
    if (!selectedLayer) return;
    const dup = {
      ...selectedLayer,
      id: Date.now(),
      x: selectedLayer.x + 20,
      y: selectedLayer.y + 20,
      zIndex: currentLayers.length + 1,
    };
    const newLayers = [...currentLayers, dup];
    setCurrentLayers(newLayers);
    commitHistory(newLayers);
    setSelectedId(dup.id);
  };
  const handleLayerPanel = () => {
    setShowLayerPanel(!showLayerPanel);
  };

  const handleRotate = () => {
    if (!selectedLayer) return;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, rotation: l.rotation + 15 } : l
    );
    commitHistory(newLayers);
  };

  const handleCrop = () => {
    // Toggle crop mode
    setIsCropping(!isCropping);
  };

  const handleFlip = () => {
    if (!selectedLayer) return;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, flipped: !l.flipped } : l
    );
    commitHistory(newLayers);
  };

  // =========================================================
  // ========== Align horizontally / vertically ==============
  // =========================================================
  const alignHorizontally = () => {
    if (!selectedLayer || !shirtRef.current) return;
    const rect = shirtRef.current.getBoundingClientRect();
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId
        ? { ...l, x: (rect.width - l.width) / 2 }
        : l
    );
    commitHistory(newLayers);
  };

  const alignVertically = () => {
    if (!selectedLayer || !shirtRef.current) return;
    const rect = shirtRef.current.getBoundingClientRect();
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId
        ? { ...l, y: (rect.height - l.height) / 2 }
        : l
    );
    commitHistory(newLayers);
  };

  // =========================================================
  // ========== Dragging layers ==============================
  // =========================================================
  const handleMouseDownLayer = (layer, e) => {
    e.stopPropagation();
    setSelectedId(layer.id);
    setDragging(true);
    setDragStart({ x: e.clientX, y: e.clientY });
    setInitPos({ x: layer.x, y: layer.y });
  };

  // We'll do the actual layer update on mouse move,
  // but only finalize it on mouseUp (commit to history).
  const handleMouseMove = (e) => {
    if (!dragging || !selectedLayer) return;
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;

    // Update to use current layers
    setCurrentLayers(
      getCurrentLayers().map((l) =>
        l.id === selectedId
          ? { ...l, x: initPos.x + dx, y: initPos.y + dy }
          : l
      )
    );
  };

  const handleMouseUp = () => {
    if (dragging) {
      commitHistory(getCurrentLayers());
    }
    setDragging(false);
  };

  // =========================================================
  // ========== File upload (Images) =========================
  // =========================================================
  const handleUploadImage = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    createImageLayer(url); // Call the function directly
  };

  // =========================================================
  // ========== Layer panel operations =======================
  // =========================================================
  const toggleLayerVisibility = (id) => {
    const newLayers = getCurrentLayers().map((l) =>
      l.id === id ? { ...l, visible: !l.visible } : l
    );
    commitHistory(newLayers);
  };

  const removeLayer = (id) => {
    const newLayers = getCurrentLayers().filter((l) => l.id !== id);
    commitHistory(newLayers);
    if (selectedId === id) setSelectedId(null);
  };

  const moveLayerUp = (id) => {
    const newLayers = [...getCurrentLayers()];
    const target = newLayers.find((x) => x.id === id);
    if (!target) return;

    const maxZ = Math.max(...newLayers.map((x) => x.zIndex));
    target.zIndex = maxZ + 1;
    commitHistory(newLayers);
  };

  const moveLayerDown = (id) => {
    const newLayers = [...getCurrentLayers()];
    const target = newLayers.find((x) => x.id === id);
    if (!target) return;

    const minZ = Math.min(...newLayers.map((x) => x.zIndex));
    target.zIndex = minZ - 1;
    commitHistory(newLayers);
  };

  // =========================================================
  // ========== Right sidebar handlers =======================
  // =========================================================
  const setCornerRadius = (corner, val) => {
    if (!selectedLayer) return;
    const numberVal = parseInt(val, 10) || 0;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId
        ? { ...l, cornerRadius: { ...l.cornerRadius, [corner]: numberVal } }
        : l
    );
    commitHistory(newLayers);
  };

  const setOffset = (axis, val) => {
    if (!selectedLayer) return;
    const numberVal = parseInt(val, 10) || 0;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, [axis]: numberVal } : l
    );
    commitHistory(newLayers);
  };

  const setBorderSide = (side, val) => {
    if (!selectedLayer) return;
    const numberVal = parseInt(val, 10) || 0;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId
        ? { ...l, border: { ...l.border, [side]: numberVal } }
        : l
    );
    commitHistory(newLayers);
  };

  const setBorderColor = (color) => {
    if (!selectedLayer) return;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, borderColor: color } : l
    );
    commitHistory(newLayers);
  };

  const setBorderStyle = (style) => {
    if (!selectedLayer) return;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, borderStyle: style } : l
    );
    commitHistory(newLayers);
  };

  const setTextColor = (color) => {
    if (!selectedLayer || selectedLayer.type !== 'text') return;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, color } : l
    );
    commitHistory(newLayers);
  };

  const updateLayerText = (id, text) => {
    const newLayers = getCurrentLayers().map((l) =>
      l.id === id ? { ...l, text } : l
    );
    commitHistory(newLayers);
  };

  /**
   * Let user adjust width/height manually in the sidebar.
   * This will not preserve aspect ratio (unless you implement that logic).
   */
  const setLayerSize = (field, val) => {
    if (!selectedLayer) return;
    const numberVal = parseInt(val, 10) || 0;
    const newLayers = getCurrentLayers().map((l) =>
      l.id === selectedId ? { ...l, [field]: numberVal } : l
    );
    commitHistory(newLayers);
  };


  if (fetchProductDetailLoading) return <ShimmerLoader />;

  const mediaFiles = productDetails?.media_files?.[0] || {};
  const FRONT_IMG = mediaFiles.front_image;
  const BACK_IMG = mediaFiles.back_image || mediaFiles.front_image;


  // =========================================================
  // ========== RENDER =======================================
  // =========================================================
  return (
    <div
      className="min-h-screen flex flex-col bg-gray-50 "
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      {/* ========== HEADER with Undo/Redo, etc. ========== */}
      <header className="bg-blue-900 border-b shadow-sm py-4 px-6">
        <div className="flex items-center justify-between bg-blue-900 text-white px-6 py-2">
          {/* Left side group */}
          <div className="flex items-center space-x-6 text-sm">
            {/* cancel and discard */}
            <div className="flex items-center space-x-2">
              <button

                className="flex items-center space-x-1 hover:opacity-80"
                onClick={handleCancelAndDiscard}
              >
                <IconX size={18} />
                <span>Cancel</span>
              </button>
            </div>



            {/* Undo / Redo */}
            <div className="flex items-center space-x-2">
              <button
                className="flex items-center space-x-1 hover:opacity-80 disabled:opacity-50"
                onClick={handleUndo}
                disabled={historyIndex <= 0}
              >
                <IconArrowBackUp size={18} />
                <span>undo</span>
              </button>
              <button
                className="flex items-center space-x-1 hover:opacity-80 disabled:opacity-50"
                onClick={handleRedo}
                disabled={
                  historyIndex === history.length - 1 || historyIndex < 0
                }
              >
                <IconArrowForwardUp size={18} />
                <span>redo</span>
              </button>
            </div>


            <button
              className="flex items-center space-x-1 hover:opacity-80"
              onClick={handleChangeTemplate}
            >
              <IconLayoutDashboard size={18} />
              <span>Change Template</span>
            </button>
            <button
              className="flex items-center space-x-1 hover:opacity-80"
              onClick={handlePreview}
            >
              <IconEye size={18} />
              <span>Preview</span>
            </button>
            <button
              className={`flex items-center space-x-1 ${hasUnsavedChanges
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-blue-400 cursor-not-allowed'
                } text-white px-4 py-2 rounded-md`}
              onClick={saveDesignToBackend}
              disabled={!hasUnsavedChanges}
            >
              <IconDeviceFloppy size={18} />
              <span className="text-sm font-medium">Save</span>
            </button>

          </div>

          {/* "Next" button on the right */}
          <button
            className="bg-yellow-400 text-black font-semibold px-4 py-1 rounded hover:bg-yellow-300"
            onClick={handleNext}
          >
            Save & CheckOut
          </button>
        </div>
      </header>

      {/* ========== BREADCRUMB BAR ========== */}
      <div className="bg-blue-900 text-white text-sm px-6 py-2 flex items-center space-x-2">
        <nav>
          <Link to="/" className="hover:underline">
            <span>Home</span>
          </Link>
          <span className="mx-2">/</span>
          <Link to={`/category/${categoryId}`} className="hover:underline">{categoryName}</Link>
          <span className="mx-2">/</span>
          <Link to={`/category/${categoryId}/detail/${subcategoryId}`} className="hover:underline">{subCategoryName}</Link>
          <span className="mx-2">/</span>
          <span className="font-medium text-[#FFD700]">Design</span>
        </nav>
      </div>

      {/* ========== CUSTOMIZATION CONTAINER ========== */}
      <div className="max-w-screen-xl mx-auto w-full px-4 mt-4">


        {/* Additional top bar with project name, etc. */}
        <div className="bg-white shadow p-3 flex items-center justify-between">
          {/* Left side: Project name */}
          <div className="flex items-center space-x-4">
            <span className="text-sm font-medium text-gray-700">
              Project name:
            </span>
            <input
              type="text"
              className="border-b border-gray-300 focus:outline-none text-gray-700 text-sm"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              style={{ width: '180px' }}
            />
          </div>
          {/* Right side (duplicate, layer, rotate, crop, etc.) */}
          <div className="flex items-center space-x-6 text-gray-700">
            <button
              className="flex items-center space-x-1 hover:text-indigo-600"
              onClick={handleDuplicate}
            >
              <IconCopy size={18} />
              <span className="text-sm">duplicate</span>
            </button>
            <button
              className="flex items-center space-x-1 hover:text-indigo-600"
              onClick={handleLayerPanel}
            >
              <IconLayersLinked size={18} />
              <span className="text-sm">layer</span>
            </button>
            <button
              className="flex items-center space-x-1 hover:text-indigo-600"
              onClick={handleRotate}
            >
              <IconRotate size={18} />
              <span className="text-sm">rotate</span>
            </button>
            <button
              className="flex items-center space-x-1 hover:text-indigo-600"
              onClick={handleCrop}
            >
              <IconCrop size={18} />
              <span className="text-sm">crop</span>
            </button>

            {/* Align dropdown */}
            <div className="relative group">
              <button className="flex items-center space-x-1 hover:text-indigo-600">
                <IconAlignCenter size={18} />
                <span className="text-sm">align</span>
              </button>
              <div className="hidden group-hover:block absolute right-0 top-6 bg-white border shadow p-2 z-50">
                <button
                  className="block text-xs px-3 py-1 w-full text-left hover:bg-gray-100"
                  onClick={alignHorizontally}
                >
                  Align Horizontal
                </button>
                <button
                  className="block text-xs px-3 py-1 w-full text-left hover:bg-gray-100"
                  onClick={alignVertically}
                >
                  Align Vertical
                </button>
              </div>
            </div>

            <button
              className="flex items-center space-x-1 hover:text-indigo-600"
              onClick={handleFlip}
            >
              <IconFlipHorizontal size={18} />
              <span className="text-sm">Flip</span>
            </button>
          </div>
        </div>

        {/* Main row: Left panel, shirt center, right panel */}
        <div className="flex gap-6 mt-6" style={{ minHeight: '500px' }}>
          {/* LEFT SIDEBAR */}
          <div className="w-48 bg-white shadow-md py-6 flex flex-col items-start">
            <button
              className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-50"
              onClick={createTextLayer}
            >
              <IconTextSize size={20} />
              <span>Text</span>
            </button>
            <label className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-50 cursor-pointer">
              <IconPhoto size={20} />
              <span>Images</span>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleUploadImage}
              />
            </label>
            <button className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-50">
              <IconCirclePlus size={20} />
              <span>Graphics</span>
            </button>
            {/* Text color (only if text layer is selected) */}
            <label className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-50 cursor-pointer">
              <IconPalette size={20} />
              <span>Design color</span>
              {selectedLayer && selectedLayer.type === 'text' && (
                <input
                  type="color"
                  className="ml-auto mr-3"
                  value={selectedLayer.color || '#000000'}
                  onChange={(e) => setTextColor(e.target.value)}
                />
              )}
            </label>
            <button className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-50">
              <IconPhotoPlus size={20} />
              <span>Pattern</span>
            </button>
          </div>

          {/* CENTER DESIGN AREA */}
          <div className="flex-1 flex flex-col items-center">
            <div
              ref={shirtRef}
              className="relative bg-white shadow-md"
              style={{ width: '500px', height: '400px' }}
            >
              <img
                src={isFront ? FRONT_IMG : BACK_IMG}
                alt="T-shirt"
                className={`w-full h-full object-cover ${isCropping ? 'opacity-60' : ''
                  }`}
              />
              {/* Render layers */}
              {getCurrentLayers().map((layer) => {
                if (!layer.visible) return null;
                const isSelected = layer.id === selectedId;
                return (
                  <div
                    key={layer.id}
                    className="absolute"
                    style={{
                      top: layer.y,
                      left: layer.x,
                      width: layer.width,
                      height: layer.height,
                      transform: `rotate(${layer.rotation}deg) scaleX(${layer.flipped ? -1 : 1
                        })`,
                      zIndex: layer.zIndex,
                      boxShadow: `${layer.offsetX}px ${layer.offsetY}px 8px rgba(0,0,0,0.2)`,
                      borderTopLeftRadius: layer.cornerRadius.tl,
                      borderTopRightRadius: layer.cornerRadius.tr,
                      borderBottomLeftRadius: layer.cornerRadius.bl,
                      borderBottomRightRadius: layer.cornerRadius.br,
                      borderTopWidth: layer.border.top,
                      borderRightWidth: layer.border.right,
                      borderBottomWidth: layer.border.bottom,
                      borderLeftWidth: layer.border.left,
                      borderColor: layer.borderColor,
                      borderStyle: layer.borderStyle,
                      cursor: 'move',
                    }}
                    onMouseDown={(e) => handleMouseDownLayer(layer, e)}
                  >
                    {layer.type === 'text' ? (
                      <input
                        type="text"
                        value={layer.text}
                        onChange={(e) =>
                          updateLayerText(layer.id, e.target.value)
                        }
                        className="bg-transparent text-center font-semibold w-full h-full focus:outline-none"
                        style={{
                          color: layer.color,
                          userSelect: 'none',
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <img
                        src={layer.src}
                        alt="layer-img"
                        className="w-full h-full object-cover pointer-events-none"
                        draggable={false}
                        style={{ userSelect: 'none' }}
                      />
                    )}
                    {/* If this layer is selected, outline it */}
                    {isSelected && (
                      <div className="absolute inset-0 border border-blue-500 pointer-events-none" />
                    )}
                  </div>
                );
              })}
            </div>

            {/* FRONT / BACK SWITCH - Branded Elegant Toggle */}
            {/* Ultra Elegant View Toggle */}
            <div className="flex mt-6 justify-center">
              <div className="inline-flex rounded-full bg-gray-100 p-1 shadow-inner border border-gray-200">
                <button
                  className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${isFront
                    ? 'bg-[#0B0C52] text-white shadow-md transform scale-105'
                    : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  onClick={() => {
                    const currentSelection = selectedId;
                    setIsFront(true);
                    setSelectedId(frontLayers.some(l => l.id === currentSelection) ? currentSelection : null);
                  }}
                >
                  <span className="flex items-center justify-center gap-1">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 12H3M12 21V3M12 21L3 12M12 21L21 12M12 3L3 12M12 3L21 12" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    Front
                  </span>
                </button>
                <button
                  className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${!isFront
                    ? 'bg-[#0B0C52] text-white shadow-md transform scale-105'
                    : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  onClick={() => {
                    const currentSelection = selectedId;
                    setIsFront(false);
                    setSelectedId(backLayers.some(l => l.id === currentSelection) ? currentSelection : null);
                  }}
                >
                  <span className="flex items-center justify-center gap-1">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M12 3H3V21H21V12M12 21V3M12 21L21 12M12 3L21 12" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    Back
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="w-52 bg-white shadow-md p-4 flex flex-col space-y-6">
            {/* Width/Height so user can resize */}
            <div>
              <h3 className="text-sm font-semibold mb-2">Size</h3>
              {selectedLayer ? (
                <div className="flex items-center space-x-2 text-xs">
                  <div className="flex flex-col">
                    <label>W</label>
                    <input
                      type="number"
                      className="border w-16 p-1"
                      value={selectedLayer.width}
                      onChange={(e) => setLayerSize('width', e.target.value)}
                    />
                  </div>
                  <div className="flex flex-col">
                    <label>H</label>
                    <input
                      type="number"
                      className="border w-16 p-1"
                      value={selectedLayer.height}
                      onChange={(e) => setLayerSize('height', e.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <p className="text-xs text-gray-400">No layer selected</p>
              )}
            </div>

            {/* Corner Radius */}
            <div>
              <h3 className="text-sm font-semibold mb-2">Corner Radius</h3>
              {selectedLayer ? (
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <label>Top-L</label>
                    <input
                      type="number"
                      className="border w-14 p-1"
                      value={selectedLayer.cornerRadius.tl}
                      onChange={(e) => setCornerRadius('tl', e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Top-R</label>
                    <input
                      type="number"
                      className="border w-14 p-1"
                      value={selectedLayer.cornerRadius.tr}
                      onChange={(e) => setCornerRadius('tr', e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Bot-L</label>
                    <input
                      type="number"
                      className="border w-14 p-1"
                      value={selectedLayer.cornerRadius.bl}
                      onChange={(e) => setCornerRadius('bl', e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Bot-R</label>
                    <input
                      type="number"
                      className="border w-14 p-1"
                      value={selectedLayer.cornerRadius.br}
                      onChange={(e) => setCornerRadius('br', e.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <p className="text-xs text-gray-400">No layer selected</p>
              )}
            </div>

            {/* Elevation */}
            <div>
              <h3 className="text-sm font-semibold mb-2">Elevation</h3>
              {selectedLayer ? (
                <div className="flex space-x-2">
                  <div className="text-xs">
                    <label>X</label>
                    <input
                      type="number"
                      className="border w-12 p-1"
                      value={selectedLayer.offsetX}
                      onChange={(e) => setOffset('offsetX', e.target.value)}
                    />
                  </div>
                  <div className="text-xs">
                    <label>Y</label>
                    <input
                      type="number"
                      className="border w-12 p-1"
                      value={selectedLayer.offsetY}
                      onChange={(e) => setOffset('offsetY', e.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <p className="text-xs text-gray-400">No layer selected</p>
              )}
            </div>

            {/* Border */}
            <div>
              <h3 className="text-sm font-semibold mb-2">Border</h3>
              {selectedLayer ? (
                <>
                  <div className="grid grid-cols-2 gap-2 text-xs mb-2">
                    <div>
                      <label>Top</label>
                      <input
                        type="number"
                        className="border w-14 p-1"
                        value={selectedLayer.border.top}
                        onChange={(e) => setBorderSide('top', e.target.value)}
                      />
                    </div>
                    <div>
                      <label>Right</label>
                      <input
                        type="number"
                        className="border w-14 p-1"
                        value={selectedLayer.border.right}
                        onChange={(e) =>
                          setBorderSide('right', e.target.value)
                        }
                      />
                    </div>
                    <div>
                      <label>Bottom</label>
                      <input
                        type="number"
                        className="border w-14 p-1"
                        value={selectedLayer.border.bottom}
                        onChange={(e) =>
                          setBorderSide('bottom', e.target.value)
                        }
                      />
                    </div>
                    <div>
                      <label>Left</label>
                      <input
                        type="number"
                        className="border w-14 p-1"
                        value={selectedLayer.border.left}
                        onChange={(e) => setBorderSide('left', e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Border style */}
                  <div className="flex items-center space-x-2 text-xs mb-2">
                    <label>Style:</label>
                    <button
                      className={`px-2 py-1 border text-xs ${selectedLayer.borderStyle === 'solid'
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-100'
                        }`}
                      onClick={() => setBorderStyle('solid')}
                    >
                      Solid
                    </button>
                    <button
                      className={`px-2 py-1 border text-xs ${selectedLayer.borderStyle === 'dashed'
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-100'
                        }`}
                      onClick={() => setBorderStyle('dashed')}
                    >
                      Dashed
                    </button>
                  </div>
                  <div className="flex flex-col text-xs">
                    <label>Border Color</label>
                    <input
                      type="color"
                      className="w-12 h-8 p-0 border"
                      value={selectedLayer.borderColor}
                      onChange={(e) => setBorderColor(e.target.value)}
                    />
                  </div>
                </>
              ) : (
                <p className="text-xs text-gray-400">No layer selected</p>
              )}
            </div>

            {/* Error Modal */}
            {showErrorModal && (
              <ErrorModal
                tittleMessage={errorModalContent.title}
                messageBody={errorModalContent.message}
                link={errorModalContent.link}
                buttonMessage={errorModalContent.buttonMessage}
                showErrorModal={showErrorModal}
                setShowErrorModal={setShowErrorModal}
              />


            )}

            {showAlertModal && (
              <AlertModal
                tittleMessage={alertModalContent.title}
                messageBody={alertModalContent.message}
                onClose={() => setShowAlertModal(false)}
              />
            )}

          </div>
        </div>


      </div>

      {/* LAYER PANEL (toggle with showLayerPanel) */}
      {showLayerPanel && (
        <div className="fixed top-20 right-20 bg-white shadow-lg border z-50 w-64 max-h-80 overflow-auto">
          <div className="p-3 border-b flex items-center justify-between">
            <h3 className="text-sm font-semibold">Layers</h3>
            <button
              className="text-sm text-gray-500 hover:text-gray-800"
              onClick={() => setShowLayerPanel(false)}
            >
              Close
            </button>
          </div>
          {getCurrentLayers().length === 0 && (
            <div className="p-3 text-xs text-gray-400">
              No layers added yet
            </div>
          )}
          {getCurrentLayers()
            .slice()
            .sort((a, b) => b.zIndex - a.zIndex)
            .map((l) => (
              <div
                key={l.id}
                className={`p-3 text-sm border-b cursor-pointer ${l.id === selectedId ? 'bg-blue-50' : ''
                  }`}
                onClick={() => setSelectedId(l.id)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                    {l.type === 'text' ? (
                      <span className="font-medium">Text: {l.text}</span>
                    ) : (
                      <span className="font-medium">Image</span>
                    )}
                    <span className="text-xs text-gray-400">
                      zIndex: {l.zIndex}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    {/* Toggle visibility */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleLayerVisibility(l.id);
                      }}
                    >
                      {l.visible ? (
                        <IconEye size={16} />
                      ) : (
                        <IconEyeOff size={16} />
                      )}
                    </button>
                    {/* Move up / down */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveLayerUp(l.id);
                      }}
                    >
                      <IconArrowBarUp size={16} />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveLayerDown(l.id);
                      }}
                    >
                      <IconArrowBarDown size={16} />
                    </button>
                    {/* Remove */}
                    <button
                      className="text-red-500"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeLayer(l.id);
                      }}
                    >
                      <IconTrash size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      {/* PREVIEW MODAL */}
      {showPreview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          {/* White box in the middle */}
          <div className="bg-white shadow-md rounded p-6 relative">
            {/* Close button */}
            <button
              onClick={() => setShowPreview(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              X
            </button>
            <h2 className="text-lg font-semibold mb-4">Design Preview</h2>
            {/* Re-render the T-shirt here just for preview */}
            <div
              className="relative bg-white"
              style={{ width: '400px', height: '300px' }}
            >
              <img
                src={isFront ? FRONT_IMG : BACK_IMG}
                alt="T-shirt"
                className="w-full h-full object-cover"
              />
              {getCurrentLayers().map((layer) => {
                if (!layer.visible) return null;
                return (
                  <div
                    key={layer.id}
                    style={{
                      position: 'absolute',
                      top: layer.y * (300 / 400), // scaled if you want
                      left: layer.x * (400 / 500),
                      width: layer.width * (400 / 500),
                      height: layer.height * (300 / 400),
                      transform: `rotate(${layer.rotation}deg) scaleX(${layer.flipped ? -1 : 1
                        })`,
                      zIndex: layer.zIndex,
                      overflow: 'hidden',
                    }}
                  >
                    {layer.type === 'text' ? (
                      <div
                        style={{
                          color: layer.color,
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          borderRadius: 2,
                        }}
                      >
                        {layer.text}
                      </div>
                    ) : (
                      <img
                        src={layer.src}
                        alt="layer-img"
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );


}